import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { mustMatchValidator } from 'src/app/modules/shared/helpers/helper';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit, OnChanges {
  public registerForm: FormGroup;
  public isLoaded: boolean = false;
  public isLoading: boolean;
  public errorMessage: any;
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  public emailVerifyForm: FormGroup;
  public user: any;
  isEmailVerified: boolean = false;
  constructor(private _router: Router,
    private _formBuilder: FormBuilder,
    private authService: AuthService,
    private toastService: ToastrService,
    private localStorageService: LocalStorageService, private api: ApiService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.errorMessage = null;
  }

  ngOnInit(): void {

    this.initForm();
    this.emailVerifyForm = this._formBuilder.group({
      otp: ['', [Validators.required, Validators.minLength(6)]],
    });
   // Listen for route changes to remove the modal-open class when navigating to /dashboard
   this._router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      if (this._router.url === '/dashboard') {
        document.body.classList.remove('modal-open');
      }
    }
  });
  }

  /**
 * Loader before loading page
 */
  ngAfterViewInit(): void {
    this.isLoaded = true;
  }
  initForm(): void {
    this.registerForm = this._formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      cpassword: ['', [Validators.required]],
    },
      { validators: mustMatchValidator('password', 'cpassword') });

    this.registerForm.valueChanges.subscribe(value => {
      delete this.errorMessage;
      // Perform actions based on the changed values
    });
  }

  /**
   * Route change
   * @param route
   */
  public routeChange(route: string) {
    this._router.navigateByUrl(route);
  }

  /**
   * Register form submit
   * @returns
   */
  public onSubmit() {
    this.isLoading = true;
   
    if (this.registerForm.invalid) {
      return;
    }
 
    let payload = {
      name: this.registerForm.value.name,
      email: this.registerForm.value.email,
      password: this.registerForm.value.password,
    }
   
    this.authService.signUp(payload).subscribe({
      next: (res: any) => {
      
        this.isLoading = false;
        this.toastService.success(res.message)
        this.localStorageService.set('user', res.data);
        this.localStorageService.set('authentication', res.data.authentication_token);
        this.localStorageService.set('user_id', res.data._id);
        this.user = this.localStorageService.get('user');
        this.openModal();
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading = false;
        // this.toastService.danger()
        this.toastService.error(err.error.message)
        this.errorMessage = err.error.message;
        this._router.navigateByUrl('/auth/register');
      },
    });
  }

  /**

  /**
   * Toggles the visibility of the password field.
   * Switches the `isPasswordVisible` flag between true and false.
   */

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  /**
   * Toggles the visibility of the confirm password field.
   * Switches the `isConfirmPasswordVisible` flag between true and false.
   */
  toggleConfirmPasswordVisibility() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  /**
   * email verification submit
   */
  public onEmailVerify() {

    this.isEmailVerified = true;
    this.api.POST('user/auth/email/verify', this.emailVerifyForm.value).subscribe({
      next: (response: any) => {
        this.localStorageService.set('session', response.data.session_token);
        setTimeout(() => {
          this.isEmailVerified = true;
          this._router.navigateByUrl('/dashboard');
        }, 2000);
      },
      error: (error: any) => {
        this.isEmailVerified = false;
        this.errorMessage = error.error.message;
      }
    });
  }

  /**
   * Gets email form controls
   */
  get formControls() {
    return this.emailVerifyForm.controls;
  }
  
   // Opens the modal
   private openModal() {
    const modal = document.getElementById('authentication-modal') as HTMLElement;
    if (modal) {
      modal.classList.remove('hidden');
      document.body.classList.add('modal-open');
      this.addModalEventListeners();
    }
  }

  // Closes the modal
   closeModal() {
    const modal = document.getElementById('authentication-modal') as HTMLElement;
    if (modal) {
      modal.classList.add('hidden');
    // Remove the class from the body to revert to normal state
    document.body.classList.remove('modal-open');
      this.removeModalEventListeners();
    }
  }

  // Adds modal event listeners (for closing)
  private addModalEventListeners() {
    const closeModalBtn = document.getElementById('closeModalBtn');
    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', this.closeModal.bind(this));
    }

    window.addEventListener('click', this.onClickOutsideModal.bind(this));
  }

  // Removes modal event listeners
  private removeModalEventListeners() {
    const closeModalBtn = document.getElementById('closeModalBtn');
    if (closeModalBtn) {
      closeModalBtn.removeEventListener('click', this.closeModal.bind(this));
    }

    window.removeEventListener('click', this.onClickOutsideModal.bind(this));
  }

  // Handles click outside the modal
  private onClickOutsideModal(event: MouseEvent) {
    const modal = document.getElementById('authentication-modal') as HTMLElement;
    if (modal && event.target === modal) {
      this.closeModal();
    }
  }
}
